import { IAddress } from "@common/redux/types/common";

export const getComment = (address: IAddress, withComma = true): string | null => {
  if (!address) return '';
  if (address.comment) return `${withComma ? ', ' : ''}${address.comment}`
  return ''
};
